(function() {

  function changeLanguage(language) {
      document.getElementById("selectedLanguageDd").value = language;
      document.getElementById("myForm").submit();
  }

  function hideCurrentLangOption() {
    var currentLang = $('#selectedLanguageDd').val().toUpperCase();
    var currentLangFull = '';

    switch (currentLang) {
    	case 'LV':
    		currentLangFull = 'Latviski';
    		break;
    	case 'EN':
    		currentLangFull = 'English';
    		break;
    	case 'RU':
    		currentLangFull = 'По-русски';
    		break;
    }

    $('.js-language:contains("' + currentLangFull + '")').parent().remove();
    $('.js-current-language-placeholder').html(currentLangFull);
  }

  hideCurrentLangOption();


  $('.language-selector__selected-language').on('click', function(e) {
    e.preventDefault();

    $(this).toggleClass('active');
    $('.language-selector__dropdown').toggle();
  });
  
})();
